import script from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeComponent.vue?vue&type=style&index=0&id=0e057a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e057a88"]])

export default __exports__